// Angular
import {
    Component,
    ViewEncapsulation,
    OnInit,
    ElementRef,
    ViewChild,
    Input,
    OnChanges,
    OnDestroy
} from '@angular/core';

// Models
import { Credentials } from '../../shared/models/credentials';

// Store
import { Store } from '@ngrx/store';
import { AppState } from '../../store';

// Actions
import * as routerActions from '../../store/router/router.actions';
import * as loginActions from '../../store/access/login/login.actions';
import * as userActions from '../../store/user/user.actions';

// Services
import { SoledadAuthenticationService } from '../../shared/services/b2b/auth.service';
import { TranslateService } from '@ngx-translate/core';

// Helpers
import { Base64, SoledadUtils } from '../../shared/lib/helpers/utils';
import { Subscriber } from '../../shared/lib/helpers/subscriber';

// Moment
import * as moment from 'moment';

import { RouterState } from '../../store/router/router.state';
import { WebtrekkService } from '../../shared/services/b2b/webtrekk.service';
import { ConnectifService } from '../../shared/services/b2b/connectif.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import * as _ from 'lodash';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    encapsulation: ViewEncapsulation.None
})
export class LoginComponent extends Subscriber implements OnInit, OnChanges, OnDestroy {
    @Input() bannerPromo;
    @Input() logo;

    ACCESSDATAKEY: string = 'soledad.accessData';
    // Form
    // loginForm: FormGroup;

    // Validation Messages
    msgLogin: string = '';
    typeOKMsgLogin: boolean;

    // Flags
    loading: boolean;
    lang: string;
    sessionExpired: boolean = false;

    username: string;
    password: string;
    rememberLoginChecked: boolean = false;

    intentSend: boolean;
    // formSubmitAttempt: boolean;

    @ViewChild('usernameField', { static: true }) usernameField: ElementRef;
    preLogin: RouterState = null;

    checkedRoute = false;
    redirectParams = false;

    bannerPromoImg: SafeUrl = '';
    logoUrl: SafeUrl = '';
    bannerPromoExists = false;
    private viewportMeta: HTMLMetaElement | null = null;
    private initialViewportContent: string = '';

    constructor(
        private authService: SoledadAuthenticationService,
        private store: Store<AppState>,
        private translate: TranslateService,
        private sanitize: DomSanitizer,
        private webtrekkService: WebtrekkService,
        private connectifService: ConnectifService
    ) {
        super();
    }

    ngOnInit(): void {
        this.disableInputZoom();

        // Manage autoFillLogin through accessData (oldB2B)
        this.autoFillLogin();

        // Register Externals
        this.registerExternals();

        this.subscribeUserData();

        // Subscribe to prelogin url
        this.subcribePreLogin();

        // Subscribe Login
        this.subscribeLogin();

        // Check if there is URL Params
        this.subscribeRoute();

        // Check if user is
        this.isLoggedInRedirects();
    }

    ngOnChanges() {
        // Get background
        if (this.bannerPromo) {
            this.bannerPromoImg = this.sanitize.bypassSecurityTrustUrl(this.bannerPromo);
        }

        if (this.logo) {
            this.logoUrl = this.sanitize.bypassSecurityTrustUrl(this.logo);
        }
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        this.restoreInputZoom();
    }

    private disableInputZoom(): void {
        this.viewportMeta = document.querySelector<HTMLMetaElement>('meta[name="viewport"]');

        if (!this.viewportMeta) {
            return;
        }

        this.initialViewportContent = this.viewportMeta.getAttribute('content') || '';
        this.viewportMeta.setAttribute(
            'content',
            'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no'
        );
    }

    private restoreInputZoom(): void {
        if (this.viewportMeta && this.initialViewportContent) {
            this.viewportMeta.setAttribute('content', this.initialViewportContent);
        }
    }

    autoFillLogin() {
        const cadena: string = localStorage.getItem(this.ACCESSDATAKEY);
        if (cadena) {
            const decode: any = this.authService.decryptCredentials(cadena);
            if (typeof decode == 'object' && decode.login && decode.password) {
                this.username = decode.login;
                this.password = decode.password;
                this.rememberLoginChecked = true;
            }
        }
    }

    registerExternals(): void {
        this.webtrekkService.registerPage('/login', 'Home', 'Login', 'Login', 'Login');
    }

    getUserInfo(): void {
        this.store.dispatch(new userActions.DoGetInfo());
    }

    subscribeUserData(): void {
        this.addSubscription(
            this.store
                .select((state) => state.user.data)
                .subscribe(
                    (data) => {
                        if (data && data.exception) {
                            this.userNotAllowed();
                        } else if (data && data.clienteCodigo && data.addresses && data.addresses.length) {
                            const allowEntities = this.authService.getAllowedEntities();
                            if (!this.isComercial(data.tipoUsuario)) {
                                this.connectifService.sendLoginEventUser(data);
                            }

                            if (data.tipoUsuario === 'CLIENTE') {
                                if (allowEntities.indexOf(data.empresa) >= 0) {
                                    this.redirectDashboard();
                                } else {
                                    this.userNotAllowed();
                                }
                            } else {
                                if (this.preLogin) {
                                    this.redirectPreLogin();
                                } else {
                                    this.redirectDashboard();
                                }
                            }
                        }
                    },
                    (error) => {
                        this.userNotAllowed();
                    }
                )
        );
    }
    subscribeRoute() {
        this.addSubscription(
            this.store
                .select((state) => state.router)
                .subscribe((router) => {
                    if (router && router.state) {
                        this.checkedRoute = true;
                        if (router.state.url.search(/code/) > 0 && this.authService.isLoggedIn()) {
                            return;
                        }
                        let queryParams = _.cloneDeep(router.state.queryParams);
                        if (!queryParams?.params && router.state.url.indexOf('#/?params=') > 0) {
                            queryParams.params = router.state.url.split('#/?params=')[1];
                        }
                        const p = queryParams.params || queryParams.code;
                        if (p) {
                            this.redirect(p, queryParams.auto);
                        }
                    }
                })
        );
    }

    subcribePreLogin() {
        this.addSubscription(
            this.store
                .select((state) => state.main.preLogin)
                .subscribe((preLogin) => {
                    this.preLogin = preLogin;
                })
        );
    }
    subscribeLogin(): void {
        this.addSubscription(
            this.store
                .select((state) => state.login)
                .subscribe((login) => {
                    if (login.result != null) {
                        if (login.result && login.logged) {
                            this.authService.generateUuidToken(this.username + this.password);

                            this.getUserInfo();
                        } else {
                            if (login.logged === true) {
                                this.translate
                                    .get('login_error')
                                    .subscribe((translation) => this.showMsgLogin(translation, false));

                                this.loading = false;
                            }
                        }
                    } else {
                        this.loading = false;
                    }
                })
        );
    }

    redirectDashboard(): void {
        this.store.dispatch(
            new routerActions.Go({
                path: ['dashboard/main']
            })
        );
    }

    redirectPreLogin(): void {
        this.store.dispatch(
            new routerActions.Go({
                path: [this.preLogin.url],
                query: this.preLogin.queryParams
            })
        );
    }

    userNotAllowed(): void {
        this.authService.removeSessionStorage();
        this.authService.removeToken();

        this.translate.get('login_error').subscribe((translation) => this.showMsgLogin(translation, false));

        this.loading = false;
    }

    isLoggedInRedirects(): void {
        if (!this.checkedRoute) {
            setTimeout(() => {
                this.isLoggedInRedirects();
            }, 150);
            return;
        }

        // Forward to dashboard if user is already loggedIn
        if (!this.redirectParams && this.authService.isLoggedIn()) {
            this.redirectDashboard();
        }
    }

    clickDoLogin(ev) {
        ev.preventDefault();
        this.intentSend = true;
        this.onSubmit();
    }

    onSubmit(): void {
        this.intentSend = true;
        if (this.username && this.password) {
            this.login();
        } else {
            this.loading = false;
        }
    }

    login(): void {
        this.loading = true;
        this.showMsgLogin('', true);
        if (this.rememberLoginChecked === true) {
            sessionStorage.setItem('remember', '1');
        }

        this.store.dispatch(
            new loginActions.DoLoginUser(
                new Credentials({
                    email: this.username,
                    password: this.password,
                    rememberLoginChecked: this.rememberLoginChecked
                })
            )
        );
    }

    isFieldValid(field: string): boolean {
        // return this.loginForm.get(field).value !== '';
        return this[field] !== '';
    }

    showMsgLogin(msg: string, success: boolean): void {
        this.typeOKMsgLogin = success;
        this.msgLogin = msg;
    }

    goRegister(event: Event) {
        event.preventDefault();

        this.store.dispatch(
            new routerActions.Go({
                path: ['signup']
            })
        );
    }

    goRememberPass(event: Event) {
        event.preventDefault();

        //  this.webtrekk.registerEvent();

        this.store.dispatch(
            new routerActions.Go({
                path: ['remember']
            })
        );
    }
    redirect(loginParam: string, auto: string = '0') {
        this.redirectParams = true;
        const loginParam64 = Base64.decode(loginParam);
        const loginParamDecode = SoledadUtils.cifrarXor(loginParam64, this.authService.getPublicKeyExtras()).split('@');

        // Validation
        const loginParamDecodeEmail = loginParamDecode[0];
        const loginParamDecodePassword = loginParamDecode[1];
        const loginParamDecodeDate = loginParamDecode[3];
        const loginParamRemember = loginParamDecode[4];

        // Not Valid Token Date
        if ((loginParamDecode && !loginParamDecodeDate) || loginParamDecodeDate.length < 8) {
            this.sessionExpired = true;
        }

        // Valid Token Date
        if (loginParamDecodeDate && loginParamDecodeDate.length >= 8) {
            // not Fresh! Token Date is not from Today
            if (loginParamDecodeDate.substring(0, 8) !== moment().format('YYYYMMDD')) {
                this.sessionExpired = true;
            }
        }

        let continueLogin = !this.sessionExpired;

        if (this.sessionExpired) {
            const cadena: string = localStorage.getItem(this.ACCESSDATAKEY);
            if (cadena) {
                const decode: any = this.authService.decryptCredentials(cadena);
                if (typeof decode == 'object' && decode.login && decode.password) {
                    continueLogin =
                        decode.login === loginParamDecodeEmail && decode.password === loginParamDecodePassword;
                }
            }
        }

        // Do login
        if (continueLogin) {
            this.store.dispatch(
                new loginActions.DoLoginUser(
                    new Credentials({
                        email: loginParamDecodeEmail,
                        password: loginParamDecodePassword,
                        auto: auto === '1',
                        rememberLoginChecked: loginParamRemember === 'true'
                    })
                )
            );
        } else {
            this.redirectParams = false;
        }
    }

    bannerPromoFail() {
        this.bannerPromoExists = false;
    }

    bannerPromoOk() {
        this.bannerPromoExists = true;
    }

    isComercial(tipo: string): boolean {
        return tipo === 'COMERCIAL';
    }
}
